import PostMessageEmitter from '../common/js/lib/PostMessageEmitter';
import store from '../redux/store';

function getEmitter()
{
    const domain = store.getState().getIn(['visitor', 'domain']);

    return new PostMessageEmitter(
        window.parent,
        domain
    );
}

export default getEmitter;



// WEBPACK FOOTER //
// ./postmessage/emitter.js